import React from "react";

import { styled } from "@mui/material/styles";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { hexToRgba } from "../../../Utils";

function ViewMembershipDetail({ data, loading }) {
  const theme = useTheme();

  const CustomTable = styled("div")(() => ({
    border: `1px solid ${theme.palette.primary.main}`,
    width: "100%",
    borderRadius: "10px",
    margin: "20px 0px 10px 0px",
    height: "auto",
  
    "@media (max-width: 900px)": {
      width: "100% !important",
    },
  }));
  
  const CustomTableHeader = styled("div")(() => ({
    display: "flex",
    flexDirection: "column",
    background: `${hexToRgba(theme.palette.primary.main, 0.20)}`,
    padding: "10px 20px",
    borderBottom: `1px solid ${theme.palette.primary.main}`,
  }));

  return (
    <CustomTable>
      <CustomTableHeader>
        <Box sx={{ fontSize: "18px", fontWeight: 600 }}>Membership Details</Box>
      </CustomTableHeader>
      <Box sx={{ padding: "10px 20px" }}>
        {loading ? (
          <CircularProgress style={{ textAlign: "center", color: "black" }} />
        ) : data?.length ? (
          data?.map((item, i) => {
            return (
              <Box
                key={i}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  gap: { xs: "15px", sm: "20px", md: "50px" },
                }}
              >
                <Typography sx={TextStyle}>{item?.name}</Typography>
                <Typography sx={TextStyle}>{item?.value || "NA"}</Typography>
              </Box>
            );
          })
        ) : (
          <p style={{ textAlign: "center" }}>No data Found</p>
        )}
      </Box>
    </CustomTable>
  );
}

export default ViewMembershipDetail;



const TextStyle = {
  color: "black",
  fontSize: "16px",
  fontWeight: 400,
  paddingTop: "5px",
};
